"use client"

import { Box, colors, Grow, NoSsr, Typography } from "@mui/material";
import CenterBox from "@v2/components/styled/CenterBox";
import { uiColors } from "@v2/lib/color";
import { useCallback } from "react";
import Countdown from "react-countdown";
import { PlpSpecialProductDiscount } from "../types";

// A campaign page is only that campaign while the clock runs, so the moment it
// runs out the page is asked for again and comes back as whatever it is next.
export default function PlpCampaignCountdown({ productDiscount }: {
    productDiscount: PlpSpecialProductDiscount,
}) {
    const onEndDiscount = useCallback(() => {
        setTimeout(() => {
            window.location.reload()
        }, 1000)
    }, [])

    return (
        <Box sx={{ textAlign: 'center' }}>
            <CenterBox sx={{
                bgcolor: colors.grey[900],
                borderRadius: 1,
                py: 2,
                mb: 1,
            }}>
                <NoSsr fallback={<Box height={70} />}>
                    <Countdown
                        autoStart
                        onComplete={onEndDiscount}
                        date={productDiscount.status === "upcoming" ? productDiscount.available_at : productDiscount.expire_at}
                        renderer={countDownRenderer}
                    />
                </NoSsr>
            </CenterBox>
            <Typography sx={{
                fontSize: { xs: 16, sm2: 18 },
                fontWeight: 800,
                color: colors.grey[900],
            }}>
                {({
                    "upcoming": `زمان زیادی نمانده؛ ${productDiscount.title} در راه است`,
                    "active": `${productDiscount.title} شروع شد؛ تا پایان فرصت محدوده`
                }[productDiscount.status])}
            </Typography>
        </Box>
    )
}

const countDownRenderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
        return <CenterBox sx={{ height: 70, width: 1 }}>
            <Grow in={true}>
                <Typography sx={{ color: '#fff' }}>شمارش معکوس به پایان رسید</Typography>
            </Grow>
        </CenterBox>
    }

    return (
        <Box sx={{
            width: 1,
            maxWidth: 375,
            px: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& > span': { color: '#fff', fontSize: 22 },
            '& div': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'space-between',
                py: 1,
                bgcolor: uiColors.primary,
                minWidth: 70,
                borderRadius: 1,
                '& span:first-of-type': {
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: 22,
                    letterSpacing: 3,
                    fontFeatureSettings: '"ss03"'
                },
                '& span:last-of-type': {
                    color: colors.grey[50],
                    fontWeight: 300,
                    fontSize: 14
                }
            }
        }}>
            <Grow in={true} style={{ transitionDelay: '0ms' }} timeout={450}>
                <Box>
                    <Typography component="span">{seconds}</Typography>
                    <Typography component="span">ثانیه</Typography>
                </Box>
            </Grow>
            <Typography component="span">:</Typography>
            <Grow in={true} style={{ transitionDelay: '100ms' }} timeout={450}>
                <Box>
                    <Typography component="span">{minutes}</Typography>
                    <Typography component="span">دقیقه</Typography>
                </Box>
            </Grow>
            <Typography component="span">:</Typography>
            <Grow in={true} style={{ transitionDelay: '200ms' }} timeout={450}>
                <Box>
                    <Typography component="span">{hours + (days * 24)}</Typography>
                    <Typography component="span">ساعت</Typography>
                </Box>
            </Grow>
        </Box>
    )
};
